import { ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule } from '@angular/router';

import { AlertAddComponent } from './alert-add.component'

const ALERT_ADD_ROUTES: Routes = [{
    path: '', component: AlertAddComponent
}];

export const ALERT_ADD_ROUTING  = RouterModule.forChild(ALERT_ADD_ROUTES);